// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--b1KK2","outerWrapper":"outerWrapper--f_ygW","colorSpan":"colorSpan--3FbuM","nameSpanWrapper":"nameSpanWrapper--1oxdm"};